import { profileConstants } from '../constants';

const initialState = {
    loading: false,
    myprofile: [],
    error: null
};

const normalizeProfileState = (profile) => {
    if (Array.isArray(profile)) {
        return profile;
    }

    if (profile && typeof profile === 'object') {
        return [profile];
    }

    return [];
};

const profileReducer = (state = initialState, action) => {
    switch (action.type) {
        case profileConstants.FETCH_MYPROFILE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case profileConstants.FETCH_MYPROFILE_SUCCESS:
            return {
                ...state,
                loading: false,
                myprofile: normalizeProfileState(action.profile),
                error: null
            };
        case profileConstants.FETCH_MYPROFILE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        case profileConstants.UPDATE_MYPROFILE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case profileConstants.UPDATE_MYPROFILE_SUCCESS: {
            const currentProfile = normalizeProfileState(state.myprofile);
            return {
                ...state,
                loading: false,
                myprofile: currentProfile.map((profile, index) => {
                    const matchesProfile =
                        action.profile &&
                        (profile.StudentProfileID === action.profile.StudentProfileID || index === 0);

                    if (!matchesProfile) {
                        return profile;
                    }

                    return {
                        ...profile,
                        UserName: action.profile.UserName,
                        Gender: action.profile.Gender,
                        FirstName: action.profile.FirstName,
                        Age: action.profile.Age,
                        LastName: action.profile.LastName,
                        EmailAddress: action.profile.EmailAddress
                    };
                })
            };
        }
        case profileConstants.UPDATE_MYPROFILE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        case profileConstants.CLEAR_PROFILE:
            return {
                ...initialState,
                myprofile: [], // Clear myprofile data on logout
            };
        default:
            return state;
    }
};

export default profileReducer;
